import { WebAppContext, type WebAppContextType } from 'app/src/shared/helpers'
import { useContext } from 'react'

export const useWebAppContext = (): WebAppContextType => {
  const context = useContext(WebAppContext)
  if (!context) {
    throw new Error('useWebAppContext must be used within a WebAppContextProvider')
  }
  return context
}
